export interface Muscle {
  name_jp: string;
  name_en: string;
  origin: string;
  insertion: string;
  innervation: string;
  blood_supply: string;
}

export interface MuscleData {
  [category: string]: Muscle[];
}

export enum GameType {
  NAME_MATCH = 'name_match',
  INNERVATION = 'innervation',
  BLOOD_SUPPLY = 'blood_supply',
  INNERVATION_OR_BLOOD = 'innervation_or_blood',
  ORIGIN_INSERTION = 'origin_insertion'
}

export interface GameQuestion {
  id: string;
  muscle: Muscle;
  question: string;
  options: string[];
  correctAnswer: string;
  type: GameType;
}

export interface GameSession {
  id: string;
  type: GameType;
  questions: GameQuestion[];
  currentQuestionIndex: number;
  score: number;
  startTime: number;
  endTime?: number;
  answers: { questionId: string; selectedAnswer: string; isCorrect: boolean }[];
  cheatMode: boolean;
}

export interface GameStats {
  totalGames: number;
  averageScore: number;
  bestTime: number;
  gameTypeStats: Record<GameType, { played: number; averageScore: number }>;
}